module.exports = __webpack_public_path__ + "static/media/siri20.4da83224.jpg";